import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import SelectOTPMethod from './SelectOTPMethod';
import OTPInputBox from './OTPInputBox';
import ChangePasswordBox from './ChangePasswordBox';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ThankYou from './ThankYou';
import SecurityQuestions from './SecurityQuestion';
import { useDispatch, useSelector } from 'react-redux';
import { getOtpMode, securityverifySelector, startSecurityQuestionForgot } from '../../../../Store/UsersAccount/userAccount.slice.selector';

// const ForgotPassword = () => {
//     const [step, setStep] = useState(0);
//     const [bname, setBname] = useState('Forgot Password');
//     const navigate = useNavigate()

//     const handleStep = (nextStep, btnname) => {
//         if (btnname) setBname(btnname)
//         setStep(nextStep);
//     };

//     const handleGoBack = () => {
//         navigate(-1)
//     };

//     return (
//         <Box
//             sx={{
//                 display: 'flex',
//                 flexDirection: 'column',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 minHeight: 'calc(100vh-128px)',
//                 // backgroundColor: '#f0f0f0',
//                 padding: 2
//             }}
//         >
//             <Box
//                 sx={{
//                     width: '45vw',
//                     backgroundColor: '#fff',
//                     padding: 4,
//                     boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.3)',
//                     borderRadius: '8px',
//                     minHeight: "60vh",
//                     textAlign: 'center'
//                 }}
//             >
//                 {/* Render only when on step 0 */}
//                 {step === 0 && (
//                     <>
//                         <SelectOTPMethod onBack={handleGoBack} onNext={() => handleStep(3)} buttonName={bname} />
//                     </>
//                 )}
//                 {/* Conditionally render other components based on step */}
//                 {step === 3 && <ChangePasswordBox onBack={() => handleStep(0)} onNext={() => handleStep(4)} buttonName={bname} />}
//                 {step === 4 && <OTPInputBox onBack={() => handleStep(3)} onNext={() => handleStep(5)} buttonName={bname} />}
//                 {step === 5 && <ThankYou buttonName={bname} />}
//             </Box>
//         </Box>
//     );
// };
const ForgotPassword = () => {
    const [step, setStep] = useState(0);
    const [bname, setBname] = useState('Forgot Password');
    const [emailValue, setEmailValue] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const methodpicked = useSelector(getOtpMode)
    const verifySecurityQuesList = useSelector(securityverifySelector);

    const loggedInUserData = { userId: '12345' }
    const securityQuesListData = [/* Your question data */];

    const handleStep = (nextStep, btnname) => {
        // console.log(nextStep, btnname, "iu")
        if (btnname) setBname(btnname);
        setStep(nextStep);
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    const handleSubmitSecurityQuestions = (data) => {
        // console.log('Dispatched Data:', data);
        dispatch(startSecurityQuestionForgot(data))
    };
    // console.log(methodpicked, "bn")
    useEffect(() => {
        if (verifySecurityQuesList === "Security Question verified") {
            handleStep(5);
        }
      }, [verifySecurityQuesList])
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: 'calc(100vh-128px)',
                padding: 2,
            }}
        >
            <Box
                sx={{
                    width: '45vw',
                    backgroundColor: '#fff',
                    padding: 4,
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.3)',
                    borderRadius: '8px',
                    minHeight: '60vh',
                    textAlign: 'center',
                }}
            >
                {step === 0 && (
                    <SelectOTPMethod
                        onBack={handleGoBack}
                        onNext={() => handleStep(3)}
                        buttonName={bname}
                    />
                )}
                {step === 2 && (
                    <SecurityQuestions
                        onBack={() => handleStep(0)}
                        onSubmit={handleSubmitSecurityQuestions}
                        questions={securityQuesListData}
                        loggedInUserData={loggedInUserData}
                        emailValue={emailValue}
                    />
                )}
                {step === 3 && (
                    <ChangePasswordBox
                        onBack={() => handleStep(0)}
                        onNext={() =>
                            methodpicked === 'Security' ? handleStep(2) : handleStep(4)
                        }
                        buttonName={bname}
                        setEmailValue={setEmailValue}
                    />
                )}
                {step === 4 && (
                    <OTPInputBox
                        onBack={() => handleStep(3)}
                        onNext={() => handleStep(5)}
                        buttonName={bname}
                    />
                )}
                {step === 5 && <ThankYou buttonName={bname} />}
            </Box>
        </Box>
    );
};

export default ForgotPassword;

// export default ForgotPassword;
